"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeographicSanctionScreeningItem = void 0;
const Field_type_1 = require("../../../types/Field.type");
const GeographicalSanctionControls_1 = require("../../enm/GeographicalSanctionControls");
exports.GeographicSanctionScreeningItem = {
    priority: 1,
    label: 'fields.enm.geographical_sanction_controls.label',
    fallbackLabel: 'Please confirm that you apply geographical sanctions controls to avoid providing services in sanctioned territories (especially North Korea, Cuba, Iran, Syria, non-government controlled regions of Ukraine), such as:',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Enum,
    options: GeographicalSanctionControls_1.GeographicalSanctionControlsRef.options,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
